import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStatuses(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/settings/product_statuses/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStatus(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/settings/product_statuses/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editStatus(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/settings/product_statuses", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteStatus(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/settings/product_statuses", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
